import axios from 'axios';

axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // If the header does not contain the token and the url not public, redirect to login
    config.baseURL = process.env.REACT_APP_API_HOST;

    if (
      process.env.REACT_APP_ENVIORNMENT === 'production' ||
      process.env.REACT_APP_ENVIORNMENT === 'development'
    ) {
      const accessToken = sessionStorage.getItem('token');
      // if token is found add it to the header
      if (accessToken) {
        if (config.method !== 'OPTIONS') {
          config.headers.authorization = `Bearer ${accessToken}`;
        }
      } else {
        return Promise.reject();
      }
      return config;
    }

    // Local Enviornment
    const accessToken =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaG9wTmFtZSI6ImFjaGFsc2hhaC5teXNob3BpZnkuY29tIn0.qIUVsCgKVO2XY0A5Cx_CUqs5of2tGxPFYHhViTWnGgc';
    // if token is found add it to the header
    if (accessToken) {
      if (config.method !== 'OPTIONS') {
        config.headers.authorization = `Bearer ${accessToken}`;
      }
    } else {
      return Promise.reject();
    }
    return config;
  },
  (error) =>
    // Do something with request error
    Promise.reject(error),
);

export default axios;
